import axios from 'axios';
import parse from 'html-react-parser';
import { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { FcAlarmClock } from "react-icons/fc";
import { useNavigate, useParams } from 'react-router-dom';
import swal from "sweetalert";
import { BASE_URL } from '../../../insightConfig/insightConfig';
import { useQuizGoingOn } from '../../Context/QuizGoingOn';
import "../../QuizComponent/QuestionLayout/QuestionLayout.css";
// import { toast } from 'react-toastify';

function AttemptQuiz({ lessonData, courseData }) {
  const navigate = useNavigate();



  const allTestsReportsArray = JSON.parse(localStorage.getItem("BookLessonReportArray"));
  //raaz work 
  const [testQuestions, setTestQuestions] = useState([])
  const [selectedQuestionNumber, setSelectedQuestionNumber] = useState(1)
  const [selectedQuestion, setSelectedQuestion] = useState()
  const [answerOfCurrentQuestion, setAnswerOfCurrentQuestion] = useState('')
  const [attemptedQuestions, setAttemptedQuestions] = useState([])
  const [markForReviewQuestionsArray, setMarkForReviewQuestionsArray] = useState([])
  const [viewedQuestionsArray, setViewedQuestionsArray] = useState([])
  const [finishTest, setFinishTest] = useState(false)
  const [questionsLoaded, setQuestionsLoaded] = useState(false);
  //global state
  const [isQuizGoingOn, setIsQuizGoingOn] = useQuizGoingOn();

  const alert = useAlert();



  let { packageid } = useParams()
  const storedAuthToken = localStorage.getItem('authtoken');

  //time functionality
  const [timeRemaining, setTimeRemaining] = useState(lessonData.QuizDuration * 60);
  const [timeUp, setTimeUp] = useState(false)

  useEffect(() => {
    const fetchTestQuestions = async () => {
      if (testQuestions?.length === 0) {
        try {
          const response = await axios.get(`${BASE_URL}/v2/get-book-lession-quetions/${lessonData?.SectionID}`)
          console.log(response.data, "response.data.questions");
          setTestQuestions(response.data.questions);
        } catch (error) {
          const errorMsg = error.response?.data?.message || "Something went wrong while fetching questions. Please try again later.";
          alert.error(errorMsg);
        }

      }
    }
    fetchTestQuestions();
  }, [lessonData.QuizDuration, lessonData.SectionID])

  useEffect(() => {
    if (testQuestions?.length > 0) {
      setQuestionsLoaded(true);
    }
  }, [testQuestions])

  useEffect(() => {
    if (questionsLoaded) {
      const allTestsReportsArray = JSON.parse(localStorage.getItem("BookLessonReportArray"));
      const currentTest = allTestsReportsArray?.find((test) => test.sectionId == lessonData.SectionID);
      if (currentTest?.isTestFinished == true) {
        setFinishTest(true)
        swal(
          "Test Finished! Please submit your test.", {
          closeOnClickOutside: false, // Prevent closing when clicking outside
          closeOnEsc: false
        }
        )
      } else if (currentTest?.remainingTime < 1) {
        setTimeUp(true)
        swal(
          "Time's up! Please submit your test.", {
          closeOnClickOutside: false, // Prevent closing when clicking outside
          closeOnEsc: false
        }
        ).then(() => {
          finalSubmitTest();
        })
      }
    }
    setIsQuizGoingOn(1);
    return () => {
      setIsQuizGoingOn(0);
    }

  }, [])





  useEffect(() => {
    if (finishTest || timeUp) {
      return
    }
    let timer = null;
    if (questionsLoaded) {
      timer = setInterval(() => {
        setTimeRemaining(prevTime => {
          if (prevTime > 0) {
            const allTestsReportsArray = JSON.parse(localStorage.getItem("BookLessonReportArray")) || [];
            const testIndex = allTestsReportsArray.findIndex(test => test.sectionId === lessonData.SectionID);
            if (testIndex !== -1) {
              const copyOfTestDetails = [...allTestsReportsArray];
              copyOfTestDetails[testIndex].remainingTime = prevTime - 1;
              localStorage.setItem("BookLessonReportArray", JSON.stringify(copyOfTestDetails));
            }
            return prevTime - 1;
          } else {
            setTimeUp(true)
            swal(
              "Time's up! Please submit your test.", {
              closeOnClickOutside: false, // Prevent closing when clicking outside
              closeOnEsc: false
            }
            ).then((yes) => {
              if (yes) {
                finalSubmitTest();
              }
            })
            clearInterval(timer);
            return 0;
          }
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [lessonData.QuizDuration, lessonData.SectionID, timeRemaining, questionsLoaded]);

  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;
















  const getCurrentTime = () => {
    const currentTime = new Date();
    let hours = currentTime.getHours();
    let minutes = currentTime.getMinutes();
    let seconds = currentTime.getSeconds();
    hours = (hours < 10 ? '0' : '') + hours;
    minutes = (minutes < 10 ? '0' : '') + minutes;
    seconds = (seconds < 10 ? '0' : '') + seconds;
    return `${hours}:${minutes}:${seconds}`;
  }



  useEffect(() => {
    if (testQuestions && testQuestions.length > 0) {
      let intialTestResponseObj = new Array(testQuestions.length).fill(null).map((_, index) => ({
        questionNumber: index + 1,
        selectedOption: '',
        correctOption: testQuestions?.find(question => question.QNo == index + 1)?.Answer,
        markForReview: false,
        isQuestionViewed: false,
      }));

      const BookLessonReportArray = JSON.parse(localStorage.getItem("BookLessonReportArray"));






      if (BookLessonReportArray && BookLessonReportArray?.length > 0) {
        const testToBeContinued = BookLessonReportArray.find((test) => test.sectionId === lessonData.SectionID);
        setTimeRemaining(testToBeContinued?.remainingTime)

        if (testToBeContinued) {
          setSelectedQuestionNumber(testToBeContinued.lastQuestion);
          setAttemptedQuestions(testToBeContinued.userResponseObj?.filter((question) => question.selectedOption)?.map((question) => question.questionNumber));
        } else {
          BookLessonReportArray.push({
            isTestFinished: false,
            sectionId: lessonData.SectionID,
            reAttempt: lessonData.reAttempt,
            startTime: new Date(),
            lastQuestion: 1,
            remainingTime: lessonData.QuizDuration * 60,
            userResponseObj: intialTestResponseObj
          });

          localStorage.setItem("BookLessonReportArray", JSON.stringify(BookLessonReportArray));
          setSelectedQuestionNumber(1);
        }
      } else {
        const newTestDetails = [{
          isTestFinished: false,
          sectionId: lessonData.SectionID,
          reAttempt: lessonData.reAttempt,
          startTime: new Date(),
          lastQuestion: 1,
          remainingTime: lessonData.QuizDuration * 60,
          userResponseObj: intialTestResponseObj,
        }];

        localStorage.setItem("BookLessonReportArray", JSON.stringify(newTestDetails));
        setSelectedQuestionNumber(1);
        setAttemptedQuestions([]);
      }
    }
  }, [testQuestions])


  useEffect(() => {
    if (selectedQuestionNumber) {
      const allTestsReportsArray = JSON.parse(localStorage.getItem("BookLessonReportArray"));

      if (allTestsReportsArray) {
        const currentTest = allTestsReportsArray?.find((test) => test.sectionId == lessonData.SectionID);

        if (selectedQuestionNumber != testQuestions.length + 1) {
          currentTest.lastQuestion = selectedQuestionNumber;
        }

        const userResponseObjForCurrentTest = currentTest?.userResponseObj
        let questionObj = userResponseObjForCurrentTest?.find((question) => question.questionNumber == selectedQuestionNumber)

        setAnswerOfCurrentQuestion(questionObj?.selectedOption)



        if (questionObj) {
          // questionObj.markForReview = false;
          questionObj.isQuestionViewed = true;
        }
        localStorage.setItem("BookLessonReportArray", JSON.stringify(allTestsReportsArray));

        setAttemptedQuestions(userResponseObjForCurrentTest?.filter((question) => question.selectedOption)?.map((question) => question.questionNumber));

        setMarkForReviewQuestionsArray(userResponseObjForCurrentTest?.filter((question) => question.markForReview == true)?.map((question) => question.questionNumber))
        setViewedQuestionsArray(userResponseObjForCurrentTest?.filter((question) => question.isQuestionViewed == true)?.map((question) => question.questionNumber))
      }
    }
    let selectedQuestion = testQuestions.find(question => question.QNo == selectedQuestionNumber)
    setSelectedQuestion(selectedQuestion)
  }, [selectedQuestionNumber, testQuestions, answerOfCurrentQuestion])














  const selectAnswerHandler = (value) => {
    setAnswerOfCurrentQuestion(value)
    const allTestsReportsArray = JSON.parse(localStorage.getItem("BookLessonReportArray"));

    const currentTest = allTestsReportsArray?.find((test) => test.sectionId == lessonData.SectionID);

    const selectedQuestionObj = currentTest?.userResponseObj?.find(questionObj => questionObj.questionNumber === selectedQuestionNumber);
    selectedQuestionObj.selectedOption = value;
    localStorage.setItem("BookLessonReportArray", JSON.stringify(allTestsReportsArray));
  }
  const handleClear = () => {
    const allTestsReportsArray = JSON.parse(localStorage.getItem("BookLessonReportArray"));
    const currentTest = allTestsReportsArray?.find((test) => test.sectionId == lessonData.SectionID);

    const selectedQuestionObj = currentTest?.userResponseObj?.find(questionObj => questionObj.questionNumber === selectedQuestionNumber);
    selectedQuestionObj.selectedOption = '';
    localStorage.setItem("BookLessonReportArray", JSON.stringify(allTestsReportsArray));
    setAnswerOfCurrentQuestion('')
  }




  const handleFinishTest = () => {
    swal({
      title: "Are you sure?",
      text: "Once finished, you will not be able to return to the test",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((yes) => {
      if (yes) {
        const allTestsReportsArray = JSON.parse(localStorage.getItem("BookLessonReportArray"));
        const currentTest = allTestsReportsArray?.find((test) => test.sectionId == lessonData.SectionID);
        currentTest.isTestFinished = true;
        localStorage.setItem("BookLessonReportArray", JSON.stringify(allTestsReportsArray));
        setFinishTest(true)
        swal(
          "Test Finished! Please submit your test."
        )
      }
    })
  }
  const deleteReportFromLS = () => {
    const indexOfCurrentTest = allTestsReportsArray?.findIndex((test) => test.sectionId == lessonData.SectionID);
    allTestsReportsArray.splice(indexOfCurrentTest, 1)
    localStorage.setItem("BookLessonReportArray", JSON.stringify(allTestsReportsArray));

  }

  const increaseAttemptCount = async () => {
    const response = await axios.post(BASE_URL + `/v2/increaseBookLessonQuizAttemptCount/${lessonData.SectionID}`)
  }


  const finalSubmitTest = async () => {
    try {
      const currentTest = allTestsReportsArray?.find((test) => test.sectionId == lessonData.SectionID);
      let totalQuestions = lessonData.QuestionCount;
      let attemptedQuestions = 0;
      let correctQuestions = 0;
      let wrongQuestions = 0;
      let correctMarks = 0;
      let wrongMarks = 0;
      let startTime = currentTest.startTime;

      let userResponseObj = currentTest.userResponseObj;


      userResponseObj.map(obj => {
        if (obj.selectedOption != '') {
          attemptedQuestions++;
          if (obj.correctOption == obj.selectedOption) {
            correctMarks = correctMarks + Number(lessonData.MarksPerQuestion)
            correctQuestions++;
          } else {
            wrongMarks = wrongMarks + Number(lessonData.NegativeMarks)
            wrongQuestions++;
          }
        }
      })
      let quizReport = { TotalQuestions: totalQuestions, AttemptedQuestions: attemptedQuestions, CorrectQuestions: correctQuestions, WrongQuestions: wrongQuestions, CorrectMarks: correctMarks, WrongMarks: wrongMarks, StartTime: startTime, AnswerSheet: JSON.stringify(userResponseObj) }
      if (currentTest?.reAttempt === false) {
        const response = await axios.post(BASE_URL + `/v2/insertBookLessonQuizReport/${lessonData.SectionID}`, quizReport)
        if (response.data.statusCode == 200) {
          deleteReportFromLS();
          swal(response.data.message, {
            icon: "success",
            buttons: {
              confirm: {
                text: "OK",
                value: true,
                visible: true,
                closeModal: true
              }
            }
          }).then(() => {
            navigate('/books/book-lesson-quiz-result', { state: { lessonData, courseData } })
          })
        }
      } else {
        deleteReportFromLS();
        increaseAttemptCount();
        navigate('/books/book-lesson-quiz-result', { state: { quizReport, lessonData, courseData } })
      }
    } catch (error) {
      swal("Oops", "Something went wrong! Please Try Again", { icon: "error" })
      console.log(error)
    }


  }

  const [unsavedChanges, setUnsavedChanges] = useState(true);
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (unsavedChanges) {
        const message = "Leave site? Changes you made may not be saved.";
        event.returnValue = message;  // Standard for most browsers
        return message;  // For some older browsers
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [unsavedChanges]);


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (unsavedChanges) {
        const message = "Leave site? Changes you made may not be saved.";
        event.returnValue = message;  // Standard for most browsers
        return message;  // For some older browsers
      }
    };
    window.addEventListener('popState', handleBeforeUnload);

    return () => {
      window.removeEventListener('popState', handleBeforeUnload);
    };
  }, [unsavedChanges]);






  return (
    <>
      {questionsLoaded ?
        <div className="" /* style={{height:'90vh', overflow: "scroll" }} */>
          <p className='bg-warning p-3 py-1 d-inline-flex rounded-pill m-1 fw-semibold'><FcAlarmClock className='me-2 mt-1' /> Time Remaining: <b className='text-danger mx-2'>{String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}</b></p>
          <div className='card questionpreviewpadding py-3' >

            <span className='text-success fw-bold'>({selectedQuestion?.QNo}). </span>{parse(selectedQuestion?.Question)}
            <ul className='answer-list' >
              <li className={answerOfCurrentQuestion?.includes('A') ? 'selected py-2' : 'py-2'} onClick={() => selectAnswerHandler('A')}>
                <input
                  type="radio"
                  className='me-2 mb-1'
                  style={{ width: "20px", height: "20px" }}
                  name='option1'
                  id='option_1'
                  onClick={() => selectAnswerHandler('A')}
                  checked={answerOfCurrentQuestion?.includes('A')}
                />
                <label htmlFor='option_1'>
                  (A)  {parse(selectedQuestion?.OptionA)}
                  {/* <b>(A) {}</b> */}
                </label>
              </li>
              <li className={answerOfCurrentQuestion?.includes('B') ? 'selected py-2' : 'py-2'} onClick={() => selectAnswerHandler('B')}>
                <input
                  type="radio"
                  className='me-2 mb-1'
                  style={{ width: "20px", height: "20px" }}
                  name='option2'
                  id='option_2'
                  onClick={() => selectAnswerHandler('B')}
                  checked={answerOfCurrentQuestion?.includes('B')}
                />
                <label htmlFor='option_2'>
                  (B)  {parse(selectedQuestion?.OptionB)}
                </label>
              </li>
              <li className={answerOfCurrentQuestion?.includes('C') ? 'selected py-2' : 'py-2'} onClick={() => selectAnswerHandler('C')}>
                <input
                  type="radio"
                  className='me-2 mb-1'
                  style={{ width: "20px", height: "20px" }}
                  name='option3'
                  id='option_3'
                  onClick={() => selectAnswerHandler('C')}
                  checked={answerOfCurrentQuestion?.includes('C')}
                />
                <label htmlFor='option_3'>
                  (C)  {parse(selectedQuestion?.OptionC)}
                </label>
              </li>
              <li className={answerOfCurrentQuestion?.includes('D') ? 'selected py-2' : 'py-2'} onClick={() => selectAnswerHandler('D')}>
                <input
                  type="radio"
                  className='me-2 mb-1'
                  style={{ width: "20px", height: "20px" }}
                  name='option4'
                  id='option_4'
                  onClick={() => selectAnswerHandler('D')}
                  checked={answerOfCurrentQuestion?.includes('D')}
                />
                <label htmlFor='option_4'>
                  (D)  {parse(selectedQuestion?.OptionD)}
                </label>
              </li>

            </ul>
          </div>
          <div className='p-3 d-flex justify-content-betweenn flex-wrap'>
            <div className='col-lg-8 py-1 pe-3 col-md-8 col-sm-8 d-flex align-items-start flex-nowrap'>
              {selectedQuestionNumber > 1 && <button type="button" className="btn bg-Question-white btn-md me-3" onClick={() => { setSelectedQuestionNumber(selectedQuestionNumber - 1); window.scrollTo(0, 80); }}>Previous</button>}
              <button type="button" className="btn bg-Question-white btn-md" onClick={handleClear}>Clear</button>
            </div>
            <div className='col-lg-4 py-1 col-md-2 col-sm-4 d-flex align-items-start justify-content-end'>
              {selectedQuestionNumber < lessonData.QuestionCount ?
                <button type="button" className='btn bg-Question-white btn-md' onClick={() => { setSelectedQuestionNumber(selectedQuestionNumber + 1); window.scrollTo(0, 80); }}>Save & Next</button>
                :
                <button type="button" className='btn bg-Question-white btn-md' onClick={finalSubmitTest}>Submit Test</button>
              }
            </div>
          </div>
        </div>
        :
        <div className="d-flex flex-column align-items-center justify-content-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <h4 className="fw-bold text-secondary">Getting your test ready...</h4>
          <p className="text-muted">Please wait while we load the questions.</p>
        </div>

      }

    </>
  )
}

export default AttemptQuiz



